import { awAttrsNoListeners, awAttrsNoStyleNoClassNoListeners, awListeners } from '~~/common/utils/awListeners';

export default {
  computed: {
    awListeners () {
      return awListeners(this.$attrs);
    },
    awAttrsNoListeners () {
      return awAttrsNoListeners(this.$attrs);
    },
    awAttrsNoStyleNoClassNoListeners () {
      return awAttrsNoStyleNoClassNoListeners(this.$attrs);
    },
  },
};
